import React from "react";
import Chart from "react-apexcharts";
import { Typography } from "@material-ui/core";

const ChartComponent = (props) => {
  return (
    <div className="w-full">
      {props.data.title && (
        <Typography
          variant="h5"
          className="mb-6 font-bold text-slate-800"
          style={{ fontSize: "1.5rem" }}
        >
          {props.data.title}
        </Typography>
      )}
      <div className="w-full overflow-hidden">
        <Chart
          options={props.data.options}
          series={props.data.series}
          type={props.data.type}
          width="100%"
          height={props.data.height || "auto"}
          xaxis={props.data.xaxis}
        />
      </div>
    </div>
  );
};

export default ChartComponent;
